import { useCatalogProductIdParams, usePdpBaseInfo } from '@domains/pdp-common';

export const useProductNameService = () => {
  const params = useCatalogProductIdParams();
  const { product } = usePdpBaseInfo(params);

  return {
    productName: product?.name ?? '',
  };
};
